// eslint-disable-next-line no-unused-vars
import App from './app';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { IntlProvider } from 'react-intl';
import { messages } from '../searchApp/services/translations.service';
import { hydrateRoot } from 'react-dom/client';

// Grab the state from a global variable injected into the server-generated HTML
const { context } = window.__PRELOADED_STATE__;

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__;

const container = document.getElementById('related-units-app');

const root = hydrateRoot(
  container,
  <IntlProvider
    locale={context.currentLang}
    messages={messages(context.currentLang)}
  >
    <App
      initialCards={context.cards}
      type={context.type}
      cardType={context.cardType}
    />
  </IntlProvider>
);
